import {usePlantConfig, useStoppageEvent} from '@domain/shifthandover'
import {ContentBox} from '@hconnect/common/components/ContentBox'
import {StoppageEvent} from '@hconnect/common/stoppages/types/stoppage.types'
import {TimeZone} from '@hconnect/common/types'
import {FeatureFlagKey, useCommonFeatureFlag} from '@hproduce/feature-flags'
import {StoppageDetails, StoppageEdit} from '@widgets/shift-event-details'
import {Dispatch, FC, SetStateAction} from 'react'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'

type StoppageSideCardProps = {
  stoppage?: StoppageEvent
  onEdit: Dispatch<SetStateAction<boolean>>
  onDelete: (stoppageEvent: StoppageEvent) => void
  onSplit: (stoppageEvent: StoppageEvent) => void
  stoppageId?: string
  isEditMode: boolean
  onEditSuccess: (stoppage: StoppageEvent) => void
  plantId: string
  timezone: TimeZone
  onClose(): void
}

export const StoppageSideCard: FC<StoppageSideCardProps> = ({
  stoppage,
  stoppageId,
  onEdit,
  onDelete,
  onSplit,
  isEditMode,
  onEditSuccess,
  plantId,
  onClose,
  timezone
}) => {
  const {
    i18n: {language}
  } = useTranslation(FEATURE_NAMESPACE)
  const isStoppageSubmitSupported = useCommonFeatureFlag(FeatureFlagKey.SubmitStoppage)
  const {data: item} = useStoppageEvent(plantId, stoppageId, {
    enabled: !stoppage
  })

  const isSplitStoppageEnabled = useCommonFeatureFlag(FeatureFlagKey.EnableSplitStoppage)
  const {data: plantConfig} = usePlantConfig({plantId, language})

  const stoppageToPreview = stoppage || item

  if (stoppageToPreview) {
    return !isEditMode ? (
      <StoppageDetails
        onDelete={() => onDelete(stoppageToPreview)}
        onEdit={() => onEdit(true)}
        onSplit={() => onSplit(stoppageToPreview)}
        stoppage={stoppageToPreview}
        plantId={plantId}
        timezone={timezone}
        isSplitStoppageEnabled={isSplitStoppageEnabled}
        isEditStoppageEnabled={true}
        isDeleteStoppageEnabled={true}
        onClose={onClose}
        shifthandoverConfig={plantConfig}
        hideSalesImpact
        isStoppageSubmitSupported={!!isStoppageSubmitSupported}
      />
    ) : (
      <StoppageEdit
        stoppage={stoppageToPreview}
        plantId={plantId}
        doClose={() => onEdit(false)}
        onSuccess={onEditSuccess}
      />
    )
  }

  return (
    <ContentBox
      data-test-id="sideCard-spinner"
      isLoading
      minHeight="450px"
      mode="max100PercentOfParentHeight"
    />
  )
}
